<template>
    <div class="p-3 border-b border-gray-200 last:border-b-0">
      <div class="grid grid-cols-2 gap-4">
        <div>
          <p><strong>Nombres:</strong> {{ user.nombres }}</p>
          <p><strong>Apellidos:</strong> {{ user.apellidos }}</p>
          <p><strong>Documento:</strong> {{ user.numero_de_documento }} </p>
          <p><strong>Tipo de documento:</strong> {{ user.tipo_de_documento }}</p>
          <p><strong>Correo electrónico:</strong> {{ user.correo_electronico }}</p>
          <p><strong>Empresa:</strong> {{ user.empresa }}</p>
          <p><strong>Teléfono:</strong> {{ user.telefono }}</p>
          <p><strong>Indicativo teléfono:</strong> {{ user.indicativo_de_telefono }}</p>
        </div>
        <div>
          <p><strong>Ciudad:</strong> {{ user.ciudad }}</p>
          <p><strong>País:</strong> {{ user.pais }}</p>
          <p><strong>Direccion:</strong> {{ user.direccion }}</p>
          <p><strong>Departamento:</strong> {{ user.departamento }}</p>
          <p><strong>Categoría:</strong> {{ user.categoria }}</p>
          <p><strong>Profesión:</strong> {{ user.profesion }}</p>
          <p><strong>Especialidad:</strong> {{ user.especialidad }}</p>
        </div>
      </div>
      <div v-if="isComplete && user.autorizado === '0'" class="mt-4">
        <button @click="$emit('approve', user.staff_id)" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
          Aprobar
        </button>
      </div>
      <p v-else-if="user.autorizado === '1'" class="mt-4 text-green-500">
        Usuario Aprobado
      </p>
      <p v-else class="mt-4 text-red-500">
        Usuario Incompleto
      </p>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      user: {
        type: Object,
        required: true
      }
    },
    computed: {
      isComplete() {
        const fields = ['nombres', 'apellidos', 'numero_de_documento', 'correo_electronico', 'telefono', 'ciudad', 'pais', 'departamento', 'categoria'];
        return fields.every(field => this.user[field] && this.user[field].trim() !== '');
      }
    }
  }
  </script>
  